module.exports = __webpack_public_path__ + "static/dj-796065cda0c4141adc8b8a5d8cb6e791.jpeg";